import config from '@/config'

const { cdn } = config

export default {
  namespaced: true,
  state: () => ({
    mixedHouseholdTrash: {
      canBeSelected: true,
      label: 'Mixed Household<br>Trash',
      value: 'mixedHouseholdTrash',
      icon: `${cdn}icons-household-trash.svg`
    },
    constructionDebris: {
      canBeSelected: true,
      label: 'Construction<br>Debris',
      value: 'constructionDebris',
      icon: `${cdn}icons-construction-debris.svg`
    },
    heavy: {
      canBeSelected: true,
      label: 'Heavy Stuff<br>(Brick, Dirt, etc)',
      value: 'heavy',
      icon: `${cdn}icons-heavy-stuff.svg`
    },
    yardOrOrganicMaterial: {
      canBeSelected: true,
      label: 'Yard or Organic<br>Material',
      value: 'yardOrOrganicMaterial',
      icon: `${cdn}icons-yard-organic-material.svg`
    }
  }),
  mutations: {
    // Project Matrix runs everytime a project is selected to apply
    // debris selection rules
    projectMatrix (state, projectType) {
      // yardCleanupOrLandscaping
      if (projectType === 'yardCleanupOrLandscaping') {
        state.mixedHouseholdTrash.canBeSelected = false
        state.constructionDebris.canBeSelected = false
        state.yardOrOrganicMaterial.canBeSelected = true
        state.heavy.canBeSelected = true
        return
      }

      if (projectType === 'homeCleanout') {
        state.mixedHouseholdTrash.canBeSelected = true
        state.constructionDebris.canBeSelected = true
        state.yardOrOrganicMaterial.canBeSelected = true
        state.heavy.canBeSelected = true
        return
      }

      if (projectType === 'homeRemodel') {
        state.mixedHouseholdTrash.canBeSelected = true
        state.constructionDebris.canBeSelected = true
        state.yardOrOrganicMaterial.canBeSelected = true
        state.heavy.canBeSelected = true
        return
      }

      if (projectType === 'bathroomOrKitchenDemo') {
        state.mixedHouseholdTrash.canBeSelected = true
        state.constructionDebris.canBeSelected = true
        state.yardOrOrganicMaterial.canBeSelected = true
        state.heavy.canBeSelected = true
        return
      }

      if (projectType === 'roofingOrSidingTearDown') {
        state.mixedHouseholdTrash.canBeSelected = true
        state.constructionDebris.canBeSelected = true
        state.yardOrOrganicMaterial.canBeSelected = false
        state.heavy.canBeSelected = false
        return
      }

      if (projectType === 'other') {
        state.mixedHouseholdTrash.canBeSelected = true
        state.constructionDebris.canBeSelected = true
        state.yardOrOrganicMaterial.canBeSelected = true
        state.heavy.canBeSelected = true
      }
    },
    // The debris matrix is run on every debris selection
    // to apply the rules of which combinations are allowed
    debrisMatrix (state, { debris, projectType }) {
      // If no debris type then apply the projectMatrix rules
      // This happens when a user has selected a debris type and then deselects
      if (!debris.length) {
        this.commit('debrisTypes/projectMatrix', projectType)
        return
      }

      // No more than 2 types debris types can be selected
      // So if the debris type has not been selected it gets disabled
      if (debris.length === 2) {
        if (!debris.includes(state.mixedHouseholdTrash.value)) {
          state.mixedHouseholdTrash.canBeSelected = false
        }
        if (!debris.includes(state.constructionDebris.value)) {
          state.constructionDebris.canBeSelected = false
        }
        if (!debris.includes(state.heavy.value)) {
          state.heavy.canBeSelected = false
        }
        if (!debris.includes(state.yardOrOrganicMaterial.value)) {
          state.yardOrOrganicMaterial.canBeSelected = false
        }
      }

      // If only one debris type is selected apply the project rules
      // and then apply the debris combination rules
      if (debris.length === 1) {
        this.commit('debrisTypes/projectMatrix', projectType)
      }

      if (projectType === 'homeCleanout') {
        if (debris.includes('yardOrOrganicMaterial')) {
          state.heavy.canBeSelected = false
        }

        if (debris.includes('heavy')) {
          state.yardOrOrganicMaterial.canBeSelected = false
        }
        return
      }

      if (projectType === 'homeRemodel') {
        if (debris.includes('yardOrOrganicMaterial')) {
          state.heavy.canBeSelected = false
        }

        if (debris.includes('heavy')) {
          state.yardOrOrganicMaterial.canBeSelected = false
        }
        return
      }

      if (projectType === 'bathroomOrKitchenDemo') {
        if (debris.includes('yardOrOrganicMaterial')) {
          state.heavy.canBeSelected = false
        }

        if (debris.includes('heavy')) {
          state.yardOrOrganicMaterial.canBeSelected = false
        }
        return
      }

      if (projectType === 'other') {
        if (debris.includes('yardOrOrganicMaterial')) {
          state.heavy.canBeSelected = false
        }

        if (debris.includes('heavy')) {
          state.yardOrOrganicMaterial.canBeSelected = false
        }
      }
    }
  }
}
